/**
 * Preferințe de mărime, memorate 48 de ore pe context gen/tip.
 *
 * Contextul are forma 'femei/imbracaminte'. Timestamp-ul e per intrare,
 * deci preferința pentru femei expiră independent de cea pentru bărbați.
 *
 * Nu atinge DOM-ul. Consumatorii se ocupă de UI.
 */
(function () {
  'use strict';

  var CHEIE = 'vb:size-prefs';
  var VERSIUNE = 1;
  var TTL_MS = 48 * 60 * 60 * 1000;

  function acum() {
    return new Date().getTime();
  }

  function citeste() {
    var brut;
    try {
      brut = window.localStorage.getItem(CHEIE);
    } catch (e) {
      return { v: VERSIUNE, prefs: {} }; // mod privat sau storage blocat
    }
    if (!brut) return { v: VERSIUNE, prefs: {} };
    var doc;
    try {
      doc = JSON.parse(brut);
    } catch (e) {
      return { v: VERSIUNE, prefs: {} };
    }
    if (
      !doc ||
      doc.v !== VERSIUNE ||
      !doc.prefs ||
      typeof doc.prefs !== 'object' ||
      Array.isArray(doc.prefs)
    ) {
      return { v: VERSIUNE, prefs: {} };
    }
    return doc;
  }

  function scrie(doc) {
    try {
      window.localStorage.setItem(CHEIE, JSON.stringify(doc));
    } catch (e) {
      /* quota depășită sau storage blocat; preferința se pierde, nu crapă */
    }
  }

  /** Șterge intrările expirate. Întoarce documentul curățat. */
  function curata(doc) {
    var limita = acum() - TTL_MS;
    var schimbat = false;
    Object.keys(doc.prefs).forEach(function (cheie) {
      var intrare = doc.prefs[cheie];
      if (!intrare || typeof intrare.ts !== 'number' || intrare.ts < limita) {
        delete doc.prefs[cheie];
        schimbat = true;
      }
    });
    if (schimbat) scrie(doc);
    return doc;
  }

  function get(context) {
    var doc = curata(citeste());
    var intrare = doc.prefs[context];
    return intrare && Array.isArray(intrare.vals) ? intrare.vals.slice() : [];
  }

  function set(context, vals) {
    if (!context || !Array.isArray(vals)) return;
    var doc = curata(citeste());
    if (vals.length === 0) {
      delete doc.prefs[context];
    } else {
      doc.prefs[context] = { vals: vals.slice(), ts: acum() };
    }
    scrie(doc);
  }

  function clear(context) {
    var doc = curata(citeste());
    delete doc.prefs[context];
    scrie(doc);
  }

  function clearAll() {
    scrie({ v: VERSIUNE, prefs: {} });
  }

  /** Toate preferințele valide, pentru indiciul din header. */
  function active() {
    var doc = curata(citeste());
    return Object.keys(doc.prefs).map(function (cheie) {
      return { context: cheie, vals: doc.prefs[cheie].vals.slice() };
    });
  }

  /**
   * Decide dacă o preferință se aplică pe un context de colecție.
   * Genul trebuie să coincidă exact. Tipul identic se potrivește.
   * O preferință îngustă se aplică pe o colecție largă
   * ('femei/imbracaminte' se aplică pe 'femei/mixt'), dar nu invers
   * ('femei/mixt' nu se aplică pe 'femei/incaltaminte').
   */
  function potrivireContext(salvat, alColectiei) {
    if (!salvat || !alColectiei) return false;
    var a = salvat.split('/');
    var b = alColectiei.split('/');
    if (a[0] !== b[0]) return false; // genul trebuie să coincidă exact
    if (a[1] === b[1]) return true;
    return b[1] === 'mixt'; // preferința îngustă se aplică pe colecția largă
  }

  window.VBSizePrefs = {
    get: get,
    set: set,
    clear: clear,
    clearAll: clearAll,
    active: active,
    potrivireContext: potrivireContext,
    _cheie: CHEIE,
    _ttlMs: TTL_MS
  };
})();
